export default {
  title: 'Pagar com {{method}}',
  hint: 'De seguida, confirme o pagamento com o seu banco ou na sua aplicação.',
  continue: 'Continuar',
  cancel: 'Cancelar pagamento',
  unavailable: 'Este método de pagamento não está disponível de momento. Escolha outro.',
};
